__turbopack_context__.v({
  "relevantQuestionnaireStatus": "RelevantQuestionnaireStatus-module__yr1rKq__relevantQuestionnaireStatus",
  "relevantQuestionnaireStatusActive": "RelevantQuestionnaireStatus-module__yr1rKq__relevantQuestionnaireStatusActive",
  "relevantQuestionnaireStatus__title": "RelevantQuestionnaireStatus-module__yr1rKq__relevantQuestionnaireStatus__title",
});
